const config = {
  initiateLoginEndpoint: process.env.REACT_APP_START_LOGIN_PAGE_URL,
  clientId: process.env.REACT_APP_CLIENT_ID,
  apiEndpoint: process.env.REACT_APP_IOT_API_ENDPOINT,
  isDevEnv: process.env.REACT_APP_IS_DEVELOPMENT === 'true',
};

export default config;
